import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import angularFilter from "angular-filter";
import core from "../../core/core.module";
import mobiusNotification from "../mobius-notification";
import notificationForm from "../notification-form/notification-form";

angular
    .module('mobiusControl.mobiusNotifications', [
        angularUIB, core, angularFilter, mobiusNotification, notificationForm
    ])
    .component('mobiusNotifications', {
        template: require('./mobius-notifications.html'),
        controller: ['notifier', '$uibModal', 'MobiusNotification', controller],
        bindings: {
            requests: '<',
            errorTypes: '<'
        }
    });

function controller(notifier, $uibModal, MobiusNotification) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.currentPage = 1;
        $ctrl.errorType = null;
        $ctrl.errorCode = null;
        $ctrl.errorMessage = null;
        $ctrl.requestSlug = null;
        $ctrl.getList();
    };

    $ctrl.filterChanged = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.clearFilters = function () {
        $ctrl.currentPage = 1;
        $ctrl.errorType = null;
        $ctrl.errorCode = null;
        $ctrl.errorMessage = null;
        $ctrl.requestSlug = null;
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        MobiusNotification
            .getList({
                currentPage: $ctrl.currentPage,
                errorType: $ctrl.errorType,
                errorCode: $ctrl.errorCode,
                errorMessage: $ctrl.errorMessage,
                requestSlug: $ctrl.requestSlug
            })
            .then(
                function (response) {
                    $ctrl.notifications = response.data.notifications;
                    $ctrl.totalCount = response.data.totalCount;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.openForm = function (notification) {
        $uibModal
            .open({
                component: 'notificationForm',
                resolve: {
                    notification: function () {
                        return notification;
                    },
                    requests: function () {
                        return $ctrl.requests;
                    },
                    errorTypes: function () {
                        return $ctrl.errorTypes;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    if (notification) {
                        notification.errorType = result.errorType;
                        notification.errorCode = result.errorCode;
                        notification.errorMessage = result.errorMessage;
                        notification.requestSlug = result.requestSlug;
                        notification.message = result.message;
                    } else {
                        $ctrl.notifications.unshift(result);
                    }
                },
                function () {

                }
            );
    };

    $ctrl.deleteItem = function (notification, ind) {
        if (!confirm('Вы действительно хотите удалить уведомление?')) {
            return;
        }
        MobiusNotification.destroy(notification.id).then(
            function () {
                notifier.successNotify('Обработчик успешно удален');
                $ctrl.notifications.splice(ind, 1);
            },
            function (error) {
                notifier.errorResponseNotify(error);
            }
        )
    };

}

export default "mobiusControl.mobiusNotifications"


// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/mobius-notifications/mobius-notifications.js